<template>
  <b-modal id="stageFinishModal" title="Этап завершен" ref="stageFinishModal"
           header-bg-variant="primary" header-text-variant="light" ok-only
           no-close-on-esc
           size="lg"
           no-close-on-backdrop
           ok-title="Ок" ok-variant="primary"
           cancel-variant="outline-primary" @ok="onOk" @close="onOk"
  >
    <div class="mt-2">Оценка: {{mark}}</div>
    <b-button
      variant="outline-primary"
      v-b-toggle.collapseMistakesTraining
      class="my-2 d-flex justify-content-between align-items-center w-100"
    >
      Допущенные ошибки
      <b-badge variant="primary" pill>{{countMistakes}}</b-badge>
    </b-button>
    <b-collapse id="collapseMistakesTraining" v-if="countMistakes">
      <div class="tableMistakes">
        <report-table :row-data="mistakes"></report-table>
      </div>
    </b-collapse>
  </b-modal>
</template>

<script>
import ReportTable from '@/components/content/education/training/progress/ReportTable.vue'

export default {
  name: 'stageFinishModal',
  components: {
    ReportTable
  },
  props: {
    countMistakes: {
      type: Number,
      default() {
        return 0
      }
    },
    mark: {
      type: Number,
      default() {
        return 0
      }
    },
    mistakes: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    onOk() {
      this.$router.push('..')
    }
  }
}
</script>

<style scoped>
.tableMistakes {
  height: 400px;
  border: 1px solid #0078c1;
}
</style>
